import { FlareDataCommentSchemaPlugin } from '@common/flare-data/plugins/flare-data-comment-schema.plugin';
import { FlareDataUnknownSchemaPlugin } from '@common/flare-data/plugins/flare-data-unknown-schema.plugin';
import { ProjectSchemaPlugin, ProjectXmlNodeName } from '@common/flare-data/plugins/project-schema.plugin';
import { FlareDataXmlSchema } from '@common/flare-data/schemas/flare-data-xml-schema';
import { CustomAttributesSchemaPlugin } from '@common/flare/schema/custom-attributes-schema-plugin';
import { TextSchemaPlugin } from '@common/flare/schema/text-schema.plugin';
import { SimpleDomDocument } from '@common/html/simple-dom/node';
import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';

export class ProjectSchema extends FlareDataXmlSchema {

  get name(): string { return 'project'; }
  get version(): string { return '0.1.0'; }

  constructor(createGuid?: () => string) {
    const schemaPlugins: SchemaPlugin[] = [
      new ProjectSchemaPlugin(), // all nodes should be configured as block-type nodes to be compatible with comments and unknown nodes
      new TextSchemaPlugin(), // add 'text' node due to prosemirror requirements
      new FlareDataCommentSchemaPlugin(), // add 'comment' as block-type node and 'textcomment' as inline-type node to support xml comments in the project document
      new FlareDataUnknownSchemaPlugin(), // add unknown tags as block-type nodes that are not managed by the project editor to allow them in the project document
      new CustomAttributesSchemaPlugin() // support custom attributes in the project document
    ];

    super(schemaPlugins, createGuid);
  }

  public validateXmlDoc(xmlDoc: SimpleDomDocument): void {
    this.validateRootElement(xmlDoc, ProjectXmlNodeName.Project);
  }

}
